import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { UtilsService } from 'src/app/_services/utils.service';

@Component({
  selector: 'app-audio',
  templateUrl: './audio.component.html',
  styleUrls: ['./audio.component.scss']
})
export class AudioComponent implements OnInit, OnChanges {
  @Input() feature: any;
  @Input() maxAudioSize: number;
  @Output() featureChange = new EventEmitter<any>();

  // Track the current feature ID to detect changes
  private currentFeatureId: string;


  quillConfiguration = {
    toolbar: [
      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      ['bold', 'italic', 'underline', 'strike'],  
      [{ 'align': [] }],      // toggled buttons
      ['blockquote', 'code-block'],
      ['link' ],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      ['clean']                                         // remove formatting button
    ]
  };
  
  constructor(private messageService: MessageService, private utils: UtilsService) {

  }

  ngOnInit()
  {
    this.initializeFeature();
    this.currentFeatureId = this.feature.id;
  }

  ngOnChanges(changes: SimpleChanges) {
    // Check if the feature has changed (different ID)
    if (changes.feature && this.feature) {
      if (this.currentFeatureId !== this.feature.id) {
        this.currentFeatureId = this.feature.id;
        this.initializeFeature();
      }
    }
  }

  private initializeFeature() {
    if(this.utils.isEmpty(this.feature.value)) {
      this.feature.value = { items: [], description: '' };
    }
    if(this.utils.isEmpty(this.feature.delete)) {
      this.feature.delete = [];
    }
  }


  audioDropped($event: any) {
    this.addAudioFiles($event);
  }

  audioBrowse(files: any) {
    this.addAudioFiles(files);
  }

  addAudioFiles(files: Array<any>) {
    for (const file of files) {
      const url = URL.createObjectURL(file);
      if (file.size > this.maxAudioSize) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `Max File size (${this.maxAudioSize / 1000000}mb) exceeded`
        });
      } else {
        let item = {
          name: file.name,
          url: url,
          size: file.size,
          isUploaded: false,
          type: "Audio",
          file: file
        };
        this.feature.value.items.push(item);
        this.featureChange.emit(this.feature);
      }
    }
  }

  deleteAudio(index: number) {
    var array = this.feature.value.items;
    var item = array.splice(index, 1);
    this.feature.delete.push(item[0].name + "." + item[0].contentType)
    this.featureChange.emit(this.feature);
  }
}